import { computed, Ref } from 'vue';
import { IStaticContentUrl, PortalType } from '@studyportals/domain-client';

import getters from '@/study-search/store/getters';

export default class ExpandableContent {
	public constructor(
		public readonly expanded: Ref<boolean>,
	) { }

	public isPortalTypeMasters = computed(() => getters.getPortalType() === PortalType.MASTER);

	public staticContentText = computed((): string | null => {
		const content = getters.getFaqStaticContent();

		return content?.staticContentText || null;
	});

	public staticContentUrls = computed((): IStaticContentUrl[] => {
		const content = getters.getFaqStaticContent();
		return content?.staticContentUrls || [];
	});
}
